module.exports = __webpack_public_path__ + "img/15.b5fec356.jpg";